import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

import { SessionContext } from "../context/session-context";

import getClients from "../functions/getClientRegister";
import RegistrationForm from "./RegistrationForm";

const useStyles = makeStyles({
    root: {

    },
    selectContainer:{
        '& .MuiSelect-select.MuiSelect-select':{
            height: 'calc(100vh - 300px)',
        },
        marginTop:10,
        marginRight:10,
        border: '2px solid #3D3E4F',
    },
    selectObject:{
        width:'100%'
    }

  });


export default function RegistrationPanel(props) {
    const classes = useStyles();
  
    const [sState, sDispatch] = useContext(SessionContext);
    const [selectedClient, setSelectedClient] = useState([]);
    const [selectedClientID, setSelectedClientID] = useState([]);
    const [clientRows, setClientRows] = useState([]);
    const [filterStr, setFilterStr] = useState('');
    const [hasUpdateRequest, setHasUpdateRequest] = useState(false);

    const [severity, setSeverity] = useState('success');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);


    /**
     * First load
     */
    useEffect(() => {

        getClients(sDispatch);

    },[])

    /**
     * Listerner for client list.
     * sState.clientList
     */
    useEffect(() => {
        if (sState.clientRegister.length > 0){
          //console.log("order rows: "+JSON.stringify(sState.orders));
          setClientRows(sState.clientRegister);

          if (hasUpdateRequest){
            setHasUpdateRequest(false);
            setSeverity('success')
            setMsg('Client has been updated.')
            setSnackOpen(true);
            clearClientDetails();
          }
        }
      },[sState.clientRegister])

    const clearClientDetails = () => {

        const c = {
            companyname: '',
            companyid: 0,
            findid: 0,
            address1: '',
            address2: '',
            city: '',
            county: '',
            country: '',
            postcode: '',
            telephone: '',
            status: 'active',
            pricemodelid: 1,
            creditlimit: 250,
            ctype: 'standard',
            username: '',
            email: '',
            utype: 'user',
            uStatus: 'active'
        }
        setSelectedClient(c);
    }

    const handleGetCompanyDetail = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        setSelectedClientID(value);
    }

    useEffect(() => {
        for (let c of clientRows) {
            if (parseInt(c.companyid) === parseInt(selectedClientID)){
                setSelectedClient(c);
                break;
            }
        }   
    },[selectedClientID])


    const handleUpdateRequest = () => {
        setHasUpdateRequest(true);
    }

    const handleSnackClose=()=>{
        setSnackOpen(false);
    }

    return (
        <div className={classes.root}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackOpen}
                autoHideDuration={6000}
                onClose={handleSnackClose}
                TransitionComponent={Slide}
                TransitionProps={{ direction: 'down' }}
            >
                <Alert onClose={handleSnackClose} severity={severity}>
                {msg}
                </Alert>
            </Snackbar>
            <Grid container>
                <Grid item xs={12}>
                    <Box className={classes.formLabel} fontWeight="500" fontStyle="italic" fontSize={22} >Newly Registered Clients</Box>
                </Grid>
                <Grid item xs={3}>
                <Box className={classes.selectContainer}>
                    <Select
                    multiple
                    native
                    value={selectedClientID}
                    onChange={handleGetCompanyDetail}
                    className={classes.selectObject}
                    inputProps={{
                        id: 'select-multiple-native',
                    }}
                    >
                    {clientRows.map((item) => (
                        <option key={item.companyid} value={item.companyid}>
                            {item.companyname}
                        </option>
                    ))}
                    </Select>

                </Box>
                </Grid>
                <Grid item xs={9}>
                    <RegistrationForm client={selectedClient} updated={handleUpdateRequest}/>
                </Grid>
            </Grid>
        </div>
    )
  };
